const getStatus = (rootState) => rootState.ws.interrupter.status;

export default getStatus;
